import { FETCH_VERSION_SUCCESS } from './types'

const versionReducer = (state, action) => {
  switch (action.type) {
    case FETCH_VERSION_SUCCESS:
      return {
        ...state,
        version: action.payload.version
      }
    default:
      return state
  }
}

export { versionReducer }
